import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import { PartnerStatus } from 'clickNgo/entities/partner/configs'

import { invalidatePartnerDataCache } from './cache'
import { changePartnerStatus } from './changePartnerStatus'

interface IInactivatePartnerRequestParams {
  partnerId: string
  locationId: string
}

export const inactivatePartnerRequest = async ({
  partnerId,
  locationId,
}: IInactivatePartnerRequestParams) => {
  const response = await changePartnerStatus({
    locationId,
    status: PartnerStatus.Inactive,
    source: ProfilingRequestSource.ClickAndGo,
  })

  if (response.status === 'success') {
    invalidatePartnerDataCache(partnerId)
  }

  return response
}
